const UserRoleEnum = Object.freeze({
    SUPERADMIN: 'super-admin',
    ADMIN: 'admin',
    PARTNER: 'partner',
    TOURNAMENTMANAGER: 'tournament-manager',
    STANDARDUSER: 'standard-user',
    TICKETINGADMIN: 'ticketing-manager',
    TICKETINGMANAGER: 'ticketing-manager', // Alias for TICKETINGADMIN
    ACTIVATIONADMIN: 'activation-admin',
    CHECKINOPERATOR: 'check-in-operator',
    TEAMCHECKINOPERATOR: 'team-check-in-operator',
    ORDERMANAGER: 'order-manager'
});

export default UserRoleEnum;
